import { DateTime } from 'luxon';
import translateMsg from '~/src/lib/translateMsg';

const getSpecialDateText = (specialgDate, lang) => {
    let d = DateTime.fromSQL(specialgDate.start).setLocale(lang);
    let tt = DateTime.fromSQL(specialgDate.end).setLocale(lang);

    const nowTest = DateTime.local();
    let dTest = DateTime.fromSQL(specialgDate.start);

    const dY = d.toFormat('yyyy');
    const tY = tt.toFormat('yyyy');

    const ddY = d.toLocaleString(DateTime.DATE_SHORT);
    const ttY = tt.toLocaleString(DateTime.DATE_SHORT);

    if (nowTest > ttY) {
        return false;
    }

    if (dY == tY) {
        if (ddY == ttY) {
            if (+specialgDate.start_full_day === 1) {
                d = d.toFormat('EEEE d MMMM yyyy');
            } else {
                d = `${d.toFormat('EEEE d MMMM')} ${translateMsg(
                    'webapp',
                    'pwa_ui__between',
                )} ${d.toFormat('HH:mm')} ${translateMsg(
                    'webapp',
                    'pwa_ui__and',
                )}  ${tt.toFormat('HH:mm')}`;
            }
        } else {
            if (+specialgDate.start_full_day === 1) {
                d = d.toFormat('EEEE d MMMM');
            } else {
                d = d.toFormat('EEEE d MMMM HH:mm');
            }
        }
    } else {
        if (+specialgDate.start_full_day === 1) {
            d = d.toFormat('EEEE d MMMM yyyy');
        } else {
            d = d.toFormat('EEEE d MMMM yyyy HH:mm');
        }
    }

    if (+specialgDate.end_full_day === 1) {
        tt = tt.toFormat('EEEE d MMMM yyyy');
    } else {
        tt = tt.toFormat('EEEE d MMMM yyyy HH:mm');
    }

    let text;

    if (specialgDate.type === 'closing') {
        if (ddY == ttY) {
            // Fermeture exceptionnelle le
            text = `${translateMsg(
                'webapp',
                'pwa_ui__exceptional_closure_on',
            )} ${d}`;
        } else {
            if (+specialgDate.end_full_day === 1) {
                if (dTest.toMillis() <= nowTest.toMillis()) {
                    // Fermeture exceptionnelle jusqu'au **** inclus
                    text = `${translateMsg(
                        'webapp',
                        'pwa_ui__exceptional_closure_until',
                    )} ${tt} ${translateMsg('webapp', 'pwa_ui__included')}`;
                } else {
                    // Fermeture exceptionnelle du **** inclus
                    text = `${translateMsg(
                        'webapp',
                        'pwa_ui__closure_from',
                    )} ${d} ${translateMsg('webapp', 'pwa_ui__date_to')} ${tt}`;
                }
            } else {
                if (dTest.toMillis() <= nowTest.toMillis()) {
                    // Fermeture exceptionnelle jusqu'au
                    text = `${translateMsg(
                        'webapp',
                        'pwa_ui__exceptional_closure_until',
                    )} ${tt}`;
                } else {
                    text = `${translateMsg(
                        'webapp',
                        'pwa_ui__exceptional_closure_from',
                    )} ${d} ${translateMsg('webapp', 'pwa_ui__at')} ${tt}`;
                }
            }
        }
    } else {
        text = `${translateMsg(
            'webapp',
            'pwa_ui__exceptional_opening_from',
        )}${d} ${translateMsg('webapp', 'pwa_ui__at')} ${tt}`;
    }

    return text;
};

export default getSpecialDateText;
